import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ type = 'forms' }) => {
  const getEmptyStateContent = () => {
    switch (type) {
      case 'forms':
        return {
          icon: 'FileText',
          title: 'No forms yet',
          description: 'Create your first form to start collecting responses and managing submissions efficiently.',
          actionText: 'Create New Form',
           actionLink: '/form-builder?new=1',
          secondaryText: 'Browse Templates',
          secondaryLink: '/templates-gallery'
        };
      case 'search':
        return {
          icon: 'Search',
          title: 'No results found',
          description: 'Try adjusting your search terms or filters to find what you\'re looking for.',
          actionText: 'Clear Filters',
          actionLink: null,
          secondaryText: null,
          secondaryLink: null
        };
      default:
        return {
          icon: 'Inbox',
          title: 'Nothing here',
          description: 'There are no items to display at the moment.',
          actionText: 'Go Back',
          actionLink: '/dashboard',
          secondaryText: null,
          secondaryLink: null
        };
    }
  };

  const content = getEmptyStateContent();

  return (
    <div className="flex items-center justify-center min-h-[400px] p-8">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon 
            name={content?.icon} 
            size={40} 
            color="var(--color-muted-foreground)" 
          />
        </div>

        <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-3">
          {content?.title}
        </h3>

        <p className="text-sm md:text-base text-muted-foreground mb-8">
          {content?.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          {content?.actionLink ? (
            <Link to={content?.actionLink}>
              <Button
                variant="default"
                size="default"
                iconName="Plus"
                iconPosition="left"
              >
                {content?.actionText}
              </Button>
            </Link>
          ) : (
            <Button
              variant="default"
              size="default"
              iconName="RotateCcw"
              iconPosition="left"
            >
              {content?.actionText}
            </Button>
          )}

          {content?.secondaryLink && (
            <Link to={content?.secondaryLink}>
              <Button
                variant="outline"
                size="default"
                iconName="LayoutTemplate"
                iconPosition="left"
              >
                {content?.secondaryText}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;